import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./EmbedBlock.module.css";

export default function EmbedBlock({ value: { html, fullWidth } }) {
  return (
    <div
      className={classNames({
        [styles.EmbedBlock]: true,
        [styles.innerColumn]: !fullWidth,
      })}
    >
      <div
        className={styles.inner}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </div>
  );
}

EmbedBlock.propTypes = {
  value: PropTypes.shape({
    url: PropTypes.shape({
      html: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }),
  }),
};
